export function trackGoal(goalName, params = undefined) {
  if (typeof window === "undefined") {
    return;
  }

  if (!goalName || typeof goalName !== "string") {
    console.warn("DataFast goal requires a string name", goalName);
    return;
  }

  try {
    const datafastFn = window?.datafast;

    if (typeof datafastFn !== "function") {
      console.warn("DataFast tracking function is unavailable");
      return;
    }

    if (params && typeof params === "object") {
      const sanitizedParams = {};

      Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) {
          return;
        }

        const normalizedKey = String(key)
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9_-]/g, "_");

        if (!normalizedKey) {
          return;
        }

        sanitizedParams[normalizedKey] = String(value).slice(0, 255);
      });

      datafastFn(goalName, sanitizedParams);
      return;
    }

    datafastFn(goalName);
  } catch (error) {
    console.warn("Failed to track DataFast goal", goalName, error);
  }
}


